let html = `<div class="info layer--width">
    <div class="info__left">
        <div class="info__title"></div>
        <div class="info__footer">
            <div class="info__vote">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.39409 0.192139L10.99 5.30994L16.7882 6.20387L12.5475 10.4277L13.5819 15.9311L8.39409 13.2425L3.20626 15.9311L4.24065 10.4277L0 6.20387L5.79819 5.30994L8.39409 0.192139Z" fill="#fff"/>
                </svg>
                <span></span>
            </div>
            <div class="info__title-original"></div>
        </div>
    </div>
    <div class="info__right">
        <div class="info__icon icon--book"></div>
        <div class="info__icon icon--like"></div>
        <div class="info__icon icon--wath"></div>
    </div>
</div>`

export default html